import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`mx-auto w-full max-w-5xl p-6 box-border`}
`;

const Header = styled.div`
  ${tw`flex items-center mb-6`}
`;

const BackButtonSkeleton = styled(Skeleton)`
  ${tw`w-32 h-8`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`ml-4 w-40 h-8`}
`;

const SectionContainer = styled.div`
  ${tw`mb-6 p-6 rounded-lg shadow-card`}
  background-color: var(--color-bg-secondary);
`;

const SectionTitleSkeleton = styled(Skeleton)`
  ${tw`w-40 h-7 mb-4 pb-2`}
`;

const ItemRow = styled.div`
  ${tw`flex justify-between py-2 border-b border-border-default`}
`;

const LabelSkeleton = styled(Skeleton)`
  ${tw`w-24 h-5`}
`;

const ValueSkeleton = styled(Skeleton)`
  ${tw`w-40 h-5`}
`;

const InvoiceDetailsSkeleton: React.FC = () => {
  return (
    <Container>
      <Header>
        <BackButtonSkeleton />
        <TitleSkeleton />
      </Header>

      {/* Basic Information Section */}
      <SectionContainer>
        <SectionTitleSkeleton />
        {Array(7)
          .fill(0)
          .map((_, index) => (
            <ItemRow key={`basic-${index}`}>
              <LabelSkeleton />
              <ValueSkeleton width={index === 0 ? '60%' : '40%'} />
            </ItemRow>
          ))}
      </SectionContainer>

      {/* Original Booking Section */}
      <SectionContainer style={{ backgroundColor: '#FECACA' }}>
        <SectionTitleSkeleton />
        {Array(5)
          .fill(0)
          .map((_, index) => (
            <ItemRow key={`original-${index}`}>
              <LabelSkeleton />
              <ValueSkeleton />
            </ItemRow>
          ))}
      </SectionContainer>

      {/* New Booking Section */}
      <SectionContainer style={{ backgroundColor: '#A7F3D0' }}>
        <SectionTitleSkeleton />
        {Array(5)
          .fill(0)
          .map((_, index) => (
            <ItemRow key={`new-${index}`}>
              <LabelSkeleton />
              <ValueSkeleton />
            </ItemRow>
          ))}
      </SectionContainer>

      {/* Price Difference */}
      <Skeleton width="100%" height="4rem" className="mt-8" />
    </Container>
  );
};

export default InvoiceDetailsSkeleton;
